module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/16_9-2de8a9b73673bb6ef3db8e43685fa81f.png";